/* URLS */

/* eslint-disable */
export const wssUrl = 'wss://i3prn7o2r6.execute-api.us-west-2.amazonaws.com/production';

export const username = 'SolarfluxAdmin'
export const password = 't66Gqcb4vKip'
//export const cloud_url = "http://127.0.0.1:8000"
export const cloud_url = "https://api.solarflux-api.co"

export const login_url = cloud_url + "/sign-in"
export const logout_url = cloud_url + "/sign-out"
export const token_url = cloud_url + "/token-auth/"
export const dishes_url = cloud_url + "/dishes/get-dishes-by-site/"
export const all_dishes_url = cloud_url + "/dishes/get-dish/"
export const sites_url = cloud_url + "/sites/get-site/"
export const raw_data_url = cloud_url + "/telemetry/get-raw-data/"
export const months_aggregate_url = cloud_url + "/telemetry/get-months-aggregate/"
export const days_performance_url = cloud_url + "/telemetry/get-days-performance/"



//export const rawMetricsURL = 'https://qtm9yjfa87.execute-api.us-east-2.amazonaws.com/prod/get-raw-csv-data';
//export const DataURL = 'https://qtm9yjfa87.execute-api.us-east-2.amazonaws.com/prod/getdaysdata';
// const DataURL = 'https://kf8fpfk75i.execute-api.us-east-2.amazonaws.com/dev/get-dashboard-data'
//export const api_key = 'dCsZLmXOCY1Hyn9b7avts6RaIS1w5ABz6lRJCkGR';





/* Data Processing Params */
export const concentratorArea = 13.94 ; // meters squared
export const specificHeatOfWater = 3559; // joules
export const readsPerMinute = 4; // once every 15 seconds
export const gallonsInTank = 115;
export const litersPerGallon = 3.785;
export const mCubedInTank =  (gallonsInTank * litersPerGallon)/1000;
/* Display */
const dayLabels = ['12AM', '1AM', '2AM', '3AM', '4AM', '5AM', '6AM', '7AM', '8AM', '9AM', '10AM', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM', '5PM', '6PM', '7PM', '8PM', '9PM', '10PM', '11PM'];
const cardinalDirections=['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
const icons = { sun: '\u2600 ', cloud: '\u2601', moon: '\u263D '};
const moonThreshold = 200;
const sunThreshold = 700*concentratorArea;
/* Downloads */
const downloadFileName = 'raw_solarflux_download.csv';